export var activityModalContainerId = function (accountid) {
    return "activity-modal-containerId".concat(accountid);
};
export var accountDetailsModalContainerId = function (accountId) {
    return "account-details-modal-containerId".concat(accountId);
};
export var statementsModalContainerId = function (accountId) {
    return "statements-modal-containerId".concat(accountId);
};
export var rewardsModalContainerId = function (accountId) {
    return "rewards-modal-containerId".concat(accountId);
};
export var accountServicesModalContainerId = function (accountId) {
    return "account-services-modal-containerId".concat(accountId);
};
export var promotionsModalContainerId = function (accountId) {
    return "promotions-modal-containerId".concat(accountId);
};
export var makeAPaymentModalContainerId = function (accountId) {
    return "make-a-payment-modal-containerId".concat(accountId);
};
export var autopayModalContainerId = function (accountId) {
    return "autopay-modal-containerId".concat(accountId);
};
//# sourceMappingURL=modalContainerId.js.map